import { YANDEX_METRICS_ID } from '@shared/constants/global';
import { Metrics } from '@shared/types/enums/metrics.enum';

export const sendMetrics = (metric: Metrics, data?: Record<string, unknown>) => {
  window.ym?.(YANDEX_METRICS_ID, 'reachGoal', metric);

  if (data) {
    window.dataLayer?.push(data);
  }
};
